import request from '@/utils/request'; // 游泳订单核销列表（独立接口）

export function fetchSwimmingOrderCheckList(data) {
  return request({
    url: '/whg-park/api/activityItem/findSwimmingOrderCheck',
    method: 'post',
    data: data
  });
}